import React, {PropsWithChildren} from "react";
import "./Modal.css";

interface Props {
  show: boolean;
  title: string
  onHide: () => void;
  backdrop?: boolean;
  position?: "center" | "top";
  className?: string;
}

export const Modal = ({
                        show,
                        title,
                        backdrop = true,
                        position = "center",
                        onHide,
                        children,
                        className
                      }: PropsWithChildren<Props>) => {

  if (!show) {
    return null;
  }

  const handleCloseButtonClick = () => {
    onHide();
  }

  const positionClass = position === "center" ? "modal-center" : "modal-top";

  return (
      <div className={`modal-container ${positionClass}`}>
        {backdrop && <div className="modal-backdrop"/>}
        <div className={`modal ${className}`}>
          <div className="modal-header">
            <div className="modal-title">{title}</div>
            <span className="modal-close-button" onClick={handleCloseButtonClick}>
              <span className="lcd-icon lcd-icon-close"/>
            </span>
          </div>
          <div className="modalBody">
            {children}
          </div>
        </div>
      </div>
  )
}